// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"thankYou-module--wrapper--3XUtd"};